import arePathnamesInSameLevel from './arePathnamesInSameLevel';

export default arePathnamesInSameLevel;
